function Price({
	num,
	round = true,
	showFree = false,
	currency = true,
	text = false,
	percent = false,
	showComplementary = false,
}) {
	//https://stackoverflow.com/a/16233919/5231665
	// Create our number formatter.
	var formatter = new Intl.NumberFormat("en-US", {
		...(currency && {
			style: "currency",
			currency: "USD",
		}),

		// These options are needed to round to whole numbers if that's what you want.
		minimumFractionDigits: round ? 0 : 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
		maximumFractionDigits: round ? 0 : 2, // (causes 2500.99 to be printed as $2,501)
	});
	if (text) {
		return formatter.format(num);
	}

	//formatter.format(2500); /* $2,500.00 */
	return (
		<>
			{isNaN(num) ? (
				<span>N/A</span>
			) : num === 0 && showFree ? (
				<span>Free</span>
			) : num === 0 && showComplementary ? (
				<span>Complimentary</span>
			) : num === 0 && !showFree ? (
				<span>{formatter.format(num)}</span>
			) : !isNaN(num) && num !== 0 && !percent ? (
				<span>{formatter.format(num)}</span>
			) : !isNaN(num) && percent ? (
				<span>{formatter.format(num)}%</span>
			) : (
				<></>
			)}

			<style jsx="true">{`
				/* span {
					font-weight: bold;
				} */
				.content {
					font-size: inherit;
					color: inherit;
					line-height: inherit;
					font-family: inherit;
					letter-spacing: inherit;
				}
			`}</style>
		</>
	);
}

export default Price;
